<app-ibase-crud-content
    [deleteRenforced]="true"
    [showHelpButton]="true"
    [defaultPaginatorConfig]="CpmCS3BucketApiService.dPaginatorConfig"
></app-ibase-crud-content>

<!-- BUGFIX: p-message disapear on modal close, making DOM dialog dynamic fix it -->
@if (helpVisible) {
    <p-dialog
        header="Help"
        [modal]="true"
        [(visible)]="helpVisible"
        [resizable]="true"
        [maximizable]="true"
        appendTo="body"
    >
        <div>
            <p>
                This component allow you to create S3 Buckets, those buckets are then used by customers to store and
                retrieve files from the S3 Bucket, for example when using the File Upload component
            </p>

            <div class="p-dialog-footer">
                <p-button
                    severity="secondary"
                    icon="pi pi-times"
                    type="button"
                    label="Close"
                    (click)="helpVisible = false"
                />
            </div>
        </div>
    </p-dialog>
}
